import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfiguration } from '../../../../../../../app-configuration';

@Injectable()
export class LpfrInstallationRestService {
  private readonly controllerUrl: string = this.appConfiguration.serverApiUrl;

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  saveLpfrFileVersion(lpfrFileVersion: string): Observable<void> {
    return this.httpClient.put<void>(this.controllerUrl + '/public/lpfr', lpfrFileVersion);
  }

  getLpfrVersion(): Observable<any> {
    return this.httpClient.get<any>(this.controllerUrl + '/public/lpfr/version');
  }
}
